import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { EInvoiceStatus } from "../../../shared/enums/invoices/EInvoice";
import { formatDate } from "../../../shared/functions/formatDate";
import { handleError } from "../../../shared/functions/handleError";
import { IInvoice } from "../../../shared/interfaces/invoice/IInvoice";
import { RootState } from "../../../store/store";
import { AdminInvoiceService } from "../service";
import InvoiceForm from "./InvoiceForm";

export const invoiceSchema = yup.object().shape({
  clientId: yup.number().required("validation.required"),
  invoiceNumber: yup.string().required("validation.required"),
  dueDate: yup.string().required("validation.required"),
  status: yup
    .mixed<EInvoiceStatus>()
    .oneOf(Object.values(EInvoiceStatus))
    .required("validation.required"),
  discount: yup
    .number()
    .min(0, "validation.minLength")
    .max(100, "validation.maxLength"),
  taxes: yup
    .number()
    .min(0, "validation.minLength")
    .max(100, "validation.maxLength"),
  sendAutomatically: yup.boolean(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required("validation.required"),
        quantity: yup.number().required("validation.required"),
        price: yup.number().required("validation.required"),
        description: yup.string(),
      }),
    )
    .required("validation.required")
    .min(1, "validation.minItems"),
});
const InvoiceCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const company = useSelector((state: RootState) => state?.companySettings);
  const { handleSubmit, control, watch, setValue } = useForm<IInvoice>({
    resolver: yupResolver(invoiceSchema) as unknown as Resolver<IInvoice>,
    defaultValues: {
      dueDate: new Date()?.toISOString(),
      items: [{ name: "", quantity: 1, price: 0, description: "" }],
      taxes: Math.round(company?.taxes ?? 0),
      discount: 0,
    },
  });
  const submitHandler = (formData: IInvoice) => {
    AdminInvoiceService.create({
      ...formData,
      dueDate: formatDate(formData.dueDate, "yyyy-MM-DD"),
    })
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyCreated", { title: formData?.invoiceNumber }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <InvoiceForm control={control} watch={watch} setValue={setValue} />
    </form>
  );
};

export default InvoiceCreate;
